import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlaGroupNameLookupComponent } from './sla-group-name-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [SlaGroupNameLookupComponent],
  exports: [SlaGroupNameLookupComponent]
})
export class SlaGroupNameLookupModule { }
